import UserProjectsPermissionWidget from './UserProjectsPermissionWidget';

export default UserProjectsPermissionWidget;
